<template>
    <div class="hs-newsletter-container" v-cloak>
        <div class="form-group mb-0">
            <input type="email" v-model="form.email"
                :class="{'is-invalid': form.errors.has('email')}"
                class="form-control font-14" :placeholder="placeholder">

            <button
                @click="onSubmit"
                :class="{'disabled': form.submitted}" :disabled="form.submitted"
                class="font-14 fw-500 btn btn-outline-primary" type="button">
            {{confirmText}}</button>

            <span
                class="invalid-feedback animated fadeIn"
                v-text="form.errors.get('email')"
                v-if="form.errors.has('email')"></span>
        </div>
    </div>
</template>

<script>
    import {Form} from '../../helpers/Form/Form';

    export default {
        props: {
            placeholder: {
                type: String,
                default: 'Inserisci la tua email'
            },
            confirmText: {
                type: String,
                default: 'Ricevi la newsletter'
            }
        },
        data() {
            return {
                form: new Form({
                    email: ''
                })
            }
        },
        methods: {
            onSubmit() {
                this.form
                    .submit('post', route('newsletter.subscribe'))
                    .then(response => {
                        window.alerts.success('Iscrizione confermata')
                    })
                    .catch(error => {
                        window.alerts.error(this.form.errors.get('email'))
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/hubspot/HubspotNewsletter.vue